module.exports = __webpack_public_path__ + "static/media/blue_plus_icon.adb19fc8.svg";